import Navigation from './_navigation.js';
import Footer from './_footer.js';
import { factory as share } from './_share.js';
import throttle from './base/_throttle.js';
import focusWithin from './base/_focus-within.js';
import keyboardFocus from './base/_keyboardFocus.js';
import smoothScroll from './base/_smoothScroll.js';
import size from './base/_size';
import tabs from './base/_tabs';
import youtube from './_youtube';

import postCard from './_postcard';
import accordion from './_accordion';
import fitlersDropdown from './_filters';
import general from './_general';
import testPlans from './_test-plans';

class CTIA {
	constructor() {
		document.addEventListener('DOMContentLoaded', this.ready.bind(this));
		window.addEventListener('load', this.load.bind(this));
		window.addEventListener('resize', throttle(this.resize.bind(this), 25));
		this.resize();
	}

	ready() {
		this.navigation = new Navigation();
		this.footer = new Footer();
		this.shares = share();

		focusWithin('label, form, fieldset');

		keyboardFocus.init();
		smoothScroll.init();
		postCard.init();
		youtube.init();
		tabs.init();
		accordion.init();
		fitlersDropdown.init();
		size.init();
		general.init();
		testPlans.init();
		window.ctia_sliders = [];
	}

	load() {
		const fb = document.getElementsByClassName('svg--facebook')[0];
		fb.insertAdjacentHTML('beforebegin', `<svg xmlns="http://www.w3.org/2000/svg" role="img" aria-label="facebook" width="24" height="24" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>`);
		fb.remove();
	}

	resize() {
		// using this to allow css to know if it should exclude the scroll bar in calc's
		if (window.innerWidth === document.body.clientWidth) {
			document.documentElement.classList.remove('has-scrollbar');
		} else {
			document.documentElement.classList.add('has-scrollbar');
		}
	}

}

export default new CTIA;
